export default {
  empresa: null,
  user: null,
  notificaciones: [],
  medios_notificacion_wa: null,
  medios_notificacion_correo: null,
  medios_notificacion_sms: null,
}
